import { render, staticRenderFns } from "./LimitFree.vue?vue&type=template&id=35eaad0d&"
import script from "./LimitFree.vue?vue&type=script&lang=js&"
export * from "./LimitFree.vue?vue&type=script&lang=js&"
import style0 from "./LimitFree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports